<!-- Groups Page Component. -->
<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>
<app-add-group-dialog
	(addGroupsDialogClose)="this.onDialogClose()"
	[currentGroups]="groups"
	[isVisible]="this.isAddGroupsVisible"
>
</app-add-group-dialog>
<div class="p-grid container">
	<div class="p-sm-10 p-md-10 p-lg-10 p-pt-3">
		<div class="card">
			<app-groups-table
				(addGroupsDialogOpen)="this.onAddGroupsOpen()"
				[groups]="groups"
				[hidden]="this.isLoading"
			></app-groups-table>
		</div>
	</div>
</div>
